module.exports = __webpack_public_path__ + "img/shopping.45fa3093.png";